import React from 'react'
import LeafTopicCard from '../../../core/components/leaf-topic-card/LeafTopicCard'
import filter from 'lodash/filter'
import HorizontalScroller from '../../../core/components/horizontal-scroller/HorizontalScroller'
import SubjectToCSSName from '../../../core/less/SubjectToCSSName'
import SubTopicCard from './SubTopicCard'
import NoLessons from './NoLessons'
import Heading from '../../../core/components/typography/heading/Heading'
import Box from '../../../core/components/box/Box'
import Column from '../../../core/components/column/Column'
import GridContainer from '../../../core/components/gridcontainer/GridContainer'
import './groupTopic.css'

const GroupTopic = ({ leaves, children, topAncestor, isSubjectTopic }) => {
  const filteredChildren = filter(children, c => !c.isLeaf)
  const leavesGenerator = style =>
    leaves.map(topic => (
      <LeafTopicCard
        className="grouptopic_leaf"
        key={topic.id}
        topic={topic}
        topAncestor={topAncestor}
        style={style}
      />
    ))
  const leavesLength = leaves ? leaves.length : 0
  return (
    <div className="grouptopic">
      {
        !isSubjectTopic
          ? <div className="grouptopic__leaves-container">
            <GridContainer>
              <Box>
                <Heading size='md' accessibilityLevel={2} fontWeight='book'>
                  <b>Study Lessons</b> ({leavesLength})
                </Heading>
              </Box>
            </GridContainer>
            <div className="grouptopic__leaves">
              {
                leavesLength
                  ? <HorizontalScroller
                    itemsGenerator={leavesGenerator}
                    itemsLength={leaves.length}
                    gutterWidth={1.1}
                    withColor={SubjectToCSSName[topAncestor.id]}
                  />
                  : <NoLessons withColor={SubjectToCSSName[topAncestor.id]} />
              }
            </div>
          </div>
          : null
      }
      {filteredChildren.length ? (
        <GridContainer>
          <Box dangerouslySetInlineStyle={{__style:{marginTop:'4rem'}}}>
            {
              !isSubjectTopic
                ? <Box marginBottom={7}>
                  <Heading size='md' accessibilityLevel={2} fontWeight='book'>
                    <b>Dive Deeper</b> ({filteredChildren.length})
                  </Heading>
                </Box>
                : <Box marginBottom={7}>
                  <Heading size='md' accessibilityLevel={2} fontWeight='book'>
                    <b>Explore Topics</b> ({filteredChildren.length})
                  </Heading>
                </Box>
            }
            <div className="grouptopic__subtopics">
              {filteredChildren.map(topic => (
                (topic.id !== 8911) && <SubTopicCard key={topic.id} topAncestor={topAncestor} topic={topic} /> // Hide topic 8911
              ))}
            </div>
          </Box>
        </GridContainer>
      ) : null}
    </div>
  )
}

export default GroupTopic



// WEBPACK FOOTER //
// ./src/domains/topic/components/GroupTopic.js